export default __webpack_public_path__ + "static/media/portfolio-6.08d165ec.jpg";